import httpClient from "./httpClient";
import { AUTH, REFRESH_TOKEN } from "./systems/endpoints.api";
import * as local from "./systems/local.users";

const userName = () => local.userName();

const authorization = (login, password) => {
  local.saveLogin(login);
  return httpClient.post(AUTH, { login, password });
};

const logOut = () => local.authorizationDelete();

const refreshToken = refreshToken =>
  httpClient.post(
    REFRESH_TOKEN,
    { refreshToken },
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
        "Content-Type": "application/json"
      }
    }
  );

const authorizationSave = auth => local.authorizationSave(auth);

const authorizationDelete = () => local.authorizationDelete();

const authorizationGet = () => local.authorizationGet();

const isSetToken = authStore => {
  let auth = authStore || authorizationGet();
  return Boolean(
    auth &&
      auth.accessToken.length > 0 &&
      auth.refreshToken.length > 0 &&
      auth.privilege.length > 0
  );
};

export {
  authorization,
  refreshToken,
  authorizationSave,
  authorizationDelete,
  authorizationGet,
  isSetToken,
  userName,
  logOut
};
